export default "__VITE_ASSET__CL2Zi8OR__"